var _path, _rect, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuides(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.04,0H3.96C1.78,0,0,1.78,0,3.96v10.07c0,2.19,1.78,3.96,3.96,3.96h14.07c2.19,0,3.96-1.78,3.96-3.96V3.96c0-2.19-1.78-3.96-3.96-3.96ZM20.55,14.04c0,1.38-1.13,2.51-2.51,2.51H3.96c-1.38,0-2.51-1.13-2.51-2.51V3.96c0-1.38,1.13-2.51,2.51-2.51h14.07c1.38,0,2.51,1.13,2.51,2.51v10.07Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.27,
    y: 5.35,
    width: 1.45,
    height: 3.45,
    fill: "currentColor"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "7.39 9.38 11.04 13.02 14.61 9.45 13.58 8.42 11.04 10.96 8.42 8.35 7.39 9.38",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuides);
export default __webpack_public_path__ + "static/media/guides.04fe80741d3cde21c8a8134bda63a281.svg";
export { ForwardRef as ReactComponent };